export default __webpack_public_path__ + "static/media/share.2b13ba5b.svg";